import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DAMAGE_REPAIRED = {
  NO: 'no',
  YES: 'yes',
} as const;

export const DAMAGE_REPAIRED_NAME = 'damage_repaired';

interface Props {
  name?: string;
}

export const RadioGroupDamageRepaired: FC<Props> = ({
  name = DAMAGE_REPAIRED_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy szkoda została naprawiona w całości?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${DAMAGE_REPAIRED.NO}`}
                value={DAMAGE_REPAIRED.NO}
                label={i18n.t('Nie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${DAMAGE_REPAIRED.YES}`}
                value={DAMAGE_REPAIRED.YES}
                label={i18n.t('Tak')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
